
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 15v-.82c0-.755-.573-1.367-1.719-1.836-1.146-.495-2.24-.742-3.281-.742-1.042 0-2.135.247-3.281.742C3.573 12.813 3 13.424 3 14.18V15h10zM9.758 5.742C9.263 5.247 8.678 5 8 5c-.677 0-1.263.247-1.758.742-.495.495-.742 1.08-.742 1.758 0 .677.247 1.263.742 1.758C6.737 9.753 7.322 10 8 10c.677 0 1.263-.247 1.758-.742.495-.495.742-1.08.742-1.758 0-.677-.247-1.263-.742-1.758zM13.82 2.5c.443 0 .834.17 1.172.508.339.338.508.729.508 1.172v11.64c0 .443-.17.834-.508 1.172-.338.339-.729.508-1.172.508H2.18c-.47 0-.873-.156-1.211-.469a1.724 1.724 0 01-.469-1.21V4.18c0-.47.156-.86.469-1.172a1.653 1.653 0 011.21-.508H3V.82h1.68V2.5h6.64V.82H13V2.5h.82z","fill":"currentColor"}})])
          )
        }
      }
    